module.exports = ".header-title {\n  font-weight: 600 !important;\n  padding-left: 0 !important; }\n\n.header-subtitle {\n  padding-left: 15px; }\n"